import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

export default function ReviewSection() {
  const { t } = useTranslation('common');
  const location = useLocation();
  const lang = location.pathname.split('/')[1];
  const currentLang = ['en', 'pt', 'de'].includes(lang) ? lang : 'en';

  const cards = [
    { title: 'review.card1', icon: 'ri-article-line' },
    { title: 'review.card2', icon: 'ri-truck-line' },
    { title: 'review.card3', icon: 'ri-building-2-line' },
    { title: 'review.card4', icon: 'ri-shield-check-line' },
    { title: 'review.card5', icon: 'ri-coupon-line' },
    { title: 'review.card6', icon: 'ri-percent-line' },
  ];

  return (
    <section className="py-16 md:py-24 bg-background-100">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="max-w-4xl mx-auto text-center mb-12">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-900 font-heading mb-4">
            {t('review.h2')}
          </h2>
          <p className="text-foreground-600 leading-relaxed max-w-2xl mx-auto">
            {t('review.description')}
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6 mb-10">
          {cards.map((card, i) => (
            <div
              key={i}
              className="group p-6 bg-background-50 rounded-xl border border-background-200 hover:border-primary-300 hover:bg-primary-50/50 transition-all duration-300 cursor-pointer"
            >
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600 mb-4">
                <i className={`${card.icon} text-lg`} />
              </div>
              <h3 className="font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors">
                {t(card.title)}
              </h3>
            </div>
          ))}
        </div>

        <div className="text-center">
          <a
            href={`/${currentLang}/articles/cssbuy-spreadsheet-guide`}
            className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 font-semibold text-sm rounded-lg hover:bg-primary-600 transition-all whitespace-nowrap"
          >
            {t('review.cta')}
            <i className="ri-arrow-right-line" />
          </a>
        </div>
      </div>
    </section>
  );
}